/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Post_Repair_PhotosInputs */

const en_case_doc_post_repair_photos = /** @type {(inputs: Case_Doc_Post_Repair_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos of repaired vehicle`)
};

const pt_br2_case_doc_post_repair_photos = /** @type {(inputs: Case_Doc_Post_Repair_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos do veículo reparado`)
};

/**
* | output |
* | --- |
* | "Photos of repaired vehicle" |
*
* @param {Case_Doc_Post_Repair_PhotosInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_post_repair_photos = /** @type {((inputs?: Case_Doc_Post_Repair_PhotosInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Post_Repair_PhotosInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_post_repair_photos(inputs)
	return pt_br2_case_doc_post_repair_photos(inputs)
});